import React, { useState } from "react";
import styles from "./CreateNewGradient.module.css";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import {
  Dropdown,
  InputField,
  TextComponent,
  SubmitButton,
} from "../../../../../components";
import { Alert } from "antd";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import MultipleCheck from "../../../../../components/MultipleCheck/MultipleCheck";
import { TagsInput } from "react-tag-input-component";

const CreateNewGradient = () => {
  const navigate = useNavigate();

  const [selected, setSelected] = useState(["Peanuts"] ,  ["Gluten"] ,  ["Eggs"]);

  const [ingredientName, setIngredientName] = useState("");
  const [currentStock, setCurrentStock] = useState();
  const [allergen, setAllergen] = useState({
    value: "Allergen",
    id: 0,
  });
  console.log("allergen", allergen);
  const [shelfLife, setShelfLife] = useState();
  const [unitOfMeasure, setUnitOfMeasure] = useState({
    value: "Unit",
    id: 0,
  });
  const [lowStockThreshold, setLowStockThreshold] = useState();
  const [category, setCategory] = useState({
    value: "Category",
    id: 0,
  });
  const [notes, setNotes] = useState("");

  const AllergenOptions = [
    { id: 1, name: "Peanut" },
    { id: 2, name: "Dairy" },
    { id: 3, name: "Gluten" },
    { id: 4, name: "Margarie" },
    { id: 5, name: "Olive Oil" },
    { id: 6, name: "Whole egg" },
  ];

  const handleSubmit = () => {
    navigate("/Warehouse/IngredientsMgmt");
  };

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Add Ingredients"}
        showBackIcon={true}
        // showFilterIcon={true}
        // showSubmitButton={true}
        // showSearch={true}
      />
      <div className={styles.subCont}>
        <div className={styles.row}>
          <InputField
            className={styles.inputNew}
            label={"Ingredient Name"}
            placeholder={"Cake Boards"}
            value={ingredientName}
            onChange={(e) => setIngredientName(e.target.value)}
          />
          <Dropdown
            className={styles.inputNew}
            label={"Unit of Measure"}
            value={unitOfMeasure}
            options={[
              { value: "Kg", id: 1 },
              { value: "Liters", id: 2 },
            ]}
            onChange={(e) => setUnitOfMeasure(e)}
          />
        </div>
        <div className={styles.row}>
          <InputField
            className={styles.inputNew}
            label={"Current Stock Level"}
            placeholder={"02"}
            value={currentStock}
            onChange={(e) => setCurrentStock(e.target.value)}
            type={"number"}
          />
          <InputField
            className={styles.inputNew}
            label={"Low Stock Threshold"}
            placeholder={"0.5"}
            value={lowStockThreshold}
            onChange={(e) => setLowStockThreshold(e.target.value)}
            type={"number"}
          />
        </div>
        <div className={styles.row}>
          <div style={{ width: "100%" }}>
            <TextComponent className={styles.allergenLabel} text={"Allergen"} />
            <div>
              <TagsInput
                value={selected}
                onChange={setSelected}
                name="Allergen"
                placeHolder="Enter Allergen"
                classNames={{ tag: "tag-cls", input: "input-cls" }}
              />
            </div>
          </div>
          <Dropdown
            className={styles.inputNew}
            label={"Category"}
            value={category}
            options={[
              { value: "Flour", id: 1 },
              { value: "Liquid", id: 2 },
              { value: "Spices", id: 3 },
            ]}
            onChange={(e) => setCategory(e)}
          />
        </div>
        <div className={styles.row}>
          <InputField
            className={styles.inputNew}
            label={"Shelf-life (Days)"}
            placeholder={"02"}
            value={shelfLife}
            onChange={(e) => setShelfLife(e.target.value)}
            type={"number"}
          />
          <InputField
            className={styles.inputNew}
            label={"Notes"}
            placeholder={"e.g., preferred vendor, storage instructions"}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div className={styles.btnContainer}>
          <SubmitButton
            title={"Add Inventory"}
            primary
            onClick={handleSubmit}
            btnClass={styles.Login_btn}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateNewGradient;
